const roleOptions = [
  {
    value: 3,
    label: "Employee",
    description:
      "Employees should have limited access, allowing them to view their own schedules, request time off, and update personal information. No access to other employees' data or system settings.",
  },
  {
    value: 2,
    label: "Manager / Supervisor",
    description:
      "Managers can create and modify schedules for employees under their supervision. They can view and manage employee information with limited admin settings.",
  },
  {
    value: -80,
    label: "Self Service",
    description:
      "This role can use the mobile app for self-service schedule activity.",
  },
  {
    value: -1,
    label: "Administrator / Superuser",
    description:
      "Full access to all system features. Can create/modify/delete schedules, manage employees, and configure system settings.",
  },
];
export default roleOptions;
